import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const choiceMenuDefaultVariants = {
  "searchable": false
}
const choiceMenuCompoundVariants = []

const choiceMenuSlotNames = [
  [
    "surface",
    "ChoiceMenu__surface"
  ],
  [
    "list",
    "ChoiceMenu__list"
  ],
  [
    "option",
    "ChoiceMenu__option"
  ],
  [
    "icon",
    "ChoiceMenu__icon"
  ],
  [
    "label",
    "ChoiceMenu__label"
  ],
  [
    "trailing",
    "ChoiceMenu__trailing"
  ],
  [
    "dividerWrap",
    "ChoiceMenu__dividerWrap"
  ],
  [
    "createRow",
    "ChoiceMenu__createRow"
  ],
  [
    "noMatches",
    "ChoiceMenu__noMatches"
  ],
  [
    "scrollArea",
    "ChoiceMenu__scrollArea"
  ]
]
const choiceMenuSlotFns = /* @__PURE__ */ choiceMenuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, choiceMenuDefaultVariants, getSlotCompoundVariant(choiceMenuCompoundVariants, slotName))])

const choiceMenuFn = memo((props = {}) => {
  return Object.fromEntries(choiceMenuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const choiceMenuVariantKeys = [
  "searchable"
]
const getVariantProps = (variants) => ({ ...choiceMenuDefaultVariants, ...compact(variants) })

export const choiceMenu = /* @__PURE__ */ Object.assign(choiceMenuFn, {
  __recipe__: false,
  __name__: 'choiceMenu',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: choiceMenuVariantKeys,
  variantMap: {
  "searchable": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, choiceMenuVariantKeys)
  },
  getVariantProps
})